import React, { useEffect, useState, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Select from "../common/form/select";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import {
    setModoTela,
    setFiltro,
    buscarSituacaoAtual,
    setAguardando,
    resetarFiltro,
    getListaCliente,
    getListaUnidadeConsumidora,
    getListaModalidadeMercadoLivre,
    getListaTipoEnergiaMercadoLivre,
    setSituacaoAtual,
} from "./diagnosticoEnergiaActions";

import { getListaSubgrupoFaturamento, getListaModalidadeTarifaria } from "../cliente/clienteActions";

import { getListaGrupoFaturamento } from "../cliente/clienteActions";
import { gerarRelatorio, incluirDownloadRealizado } from "../fatura/faturaActions.js";

import { DisplayPDF } from "../displayPDF/displayPDF.jsx";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";

import { Loading } from "../common/loading/loading";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Button from "../common/button/button";
import { setInfo, setWarning } from "../common/toast/toast";
import RenderizarAnaliseMercadoLivre from "./diagnosticoMercadoLivre";
import RenderizarAnaliseOpcaoTarifariaOptanteAB from "./diagnosticoOpcaoTarifariaOptanteAB";
import RenderizarAnaliseOpcaoTarifariaOptanteBA from "./diagnosticoOpcaoTarifariaOptanteBA";
import AlertIcon from "../common/alertIcon/alertIcon";
import { convertToBase64 } from "../utils/convertToBase64.js";
import LabelAndCheckbox from "../common/form/labelAndCheckbox.jsx";
import { ModalAlert } from "../common/dialog/modalAlert.jsx";
import NumberFormat from "react-number-format";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria.jsx";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor.jsx";

function DiagnosticoEnergia(props) {
    if (!props.usuarioLogado) return <div></div>;

    const contentCardRef = useRef();
    const [analises, setAnalises] = useState([]);
    const [exibirModalExcedenteForaPonta, setExibirModalExcedenteForaPonta] = useState(false);
    const [exibirModalExcedentePonta, setExibirModalExcedentePonta] = useState(false);
    const [exibirSelectTipoAnalise, setExibirSelectTipoAnalise] = useState(false);
    const [tipoAnalise, setTipoAnalise] = useState(null);
    const [loading, setLoading] = useState(false);
    const [exibirUltrapassagemDemanda, setExibirUltrapassagemDemanda] = useState(false);
    const [exibirModalGestorConcessionaria, setExibirModalGestorConcessionaria] = useState(false);
    const [itemSelecionado, setItemSelecionado] = useState(null);

    useEffect(() => {
        props.getListaSubgrupoFaturamento();
        props.getListaModalidadeTarifaria();
        props.getListaCliente();
        props.getListaGrupoFaturamento();
        props.getListaUnidadeConsumidora();
        props.getListaModalidadeMercadoLivre();
        props.getListaTipoEnergiaMercadoLivre();
        if (props.usuarioLogado && props.usuarioLogado.acesso_cliente) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: props.usuarioLogado.id_cliente,
            });
        }
    }, []);

    const usuarioLogadoAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;
    const ucFiltrada = props.listaUnidadeConsumidora.find((item) => item.id == props.filtro.id_unidade_consumidora) || {};
    const listaTipoAnaliseFiltrada = props.listaTipoAnalise.filter((item) => {
        // LIBERADO APENAS PARA GRUPO FATURAMENTO 1 e 4 -> { id: "Mercado Livre", valor: "Mercado Livre" },
        // LIBERADO PARA QUALQUER UC ->                    { id: "Aluguel de Usina", valor: "Aluguel de Usina" },
        // LIBERADO APENAS PARA GRUPO FATURAMENTO 3 e 4 -> { id: "Opção Tarifária (Optantes A ou B)", valor: "Opção Tarifária (Optantes A ou B)" },
        // LIBERADO APENAS PARA GRUPO FATURAMENTO 1 e 4 -> { id: "Modalidade Tarifária (Verde ou Azul)", valor: "Modalidade Tarifária (Verde ou Azul)" },
        // LIBERADO PARA QUALQUER UC ->                 -> { id: "Geração Própria", valor: "Geração Própria" }

        const tipoAindaNaoFoiAnalisado = !analises.find((a) => a.tipoAnalise === item.valor);
        return (
            (["Aluguel de Usina", "Geração Própria"].includes(item.valor) ||
                (["Opção Tarifária (Optantes A ou B)"].includes(item.valor) && [3, 4].includes(ucFiltrada.id_grupo_faturamento)) ||
                (["Mercado Livre", "Modalidade Tarifária (Verde ou Azul)"].includes(item.valor) && [1, 4].includes(ucFiltrada.id_grupo_faturamento))) &&
            tipoAindaNaoFoiAnalisado
        );
    });

    async function formatarTabela({ el, borderColor }) {
        if (!el) return;
        el.style.zoom = "0.8"; // 🔹 diminui a tabela em 80% do tamanho original
        if (window.innerWidth < 768) {
            el.style.fontSize = "0.7rem";
            el.style.width = 1000 + "px";
        } else {
            el.style.minWidth = "98%"; // `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase()}px`;
        }
        el.style.tableLayout = "fixed";
        el.style.borderCollapse = "collapse";
        el.style.border = `1px solid ${borderColor}`;
        // Aplica bordas também às células (th, td)
        const celulas = el.querySelectorAll("th, td");
        for (const celula of celulas) {
            celula.style.border = `1px solid ${borderColor}`;
            const divSelects = celula.querySelector("div#selects");
            if (divSelects) {
                divSelects.classList.remove("row"); // remove a classe "row"
                divSelects.style.display = "flex";
                divSelects.style.gap = "20px";
                divSelects.style.alignItems = "center"; // opcional
                divSelects.style.justifyContent = "flex-start"; // opcional
            }

            // Remove botões dentro do td
            celula.querySelectorAll("button").forEach((btn) => btn.remove());

            // Remove SVGs dentro do td
            celula.querySelectorAll("svg").forEach((svg) => svg.remove());

            // Remove checkboxes dentro do td
            celula.querySelectorAll('input[type="checkbox"]').forEach((chk) => chk.remove());

            const imagens = celula.querySelectorAll("img");

            for (const img of imagens) {
                let novaImg = document.createElement("img");

                if (img.alt === "Economizou") {
                    novaImg.src = await convertToBase64("/images/avatar_gradios_positivo.png");
                } else if (img.alt === "Não economizou") {
                    novaImg.src = await convertToBase64("/images/avatar_gradios_negativo.png");
                }

                // mantém estilos básicos
                novaImg.style.maxWidth = "100%";
                novaImg.style.maxHeight = "100%";
                novaImg.style.display = "inline-block";

                // substitui a imagem antiga
                img.replaceWith(novaImg);
            }
        }
    }

    if (props.pdf) {
        return (
            <DisplayPDF
                setDownloadRealizado={() => props.incluirDownloadRealizado([props.id_pdf])}
                closePdf={props.setArquivoPDF}
                pdfBase64={props.pdf}
                nomePdf={props.nomePdf}
                zoomParametro={1.5}
            />
        );
    }

    function getTituloImpressao(props) {
        const cliente = props.listaCliente.find((cli) => cli.id == props.filtro.id_cliente);
        const uc = listarUCsFiltradas().find((cli) => cli.id == props.filtro.id_unidade_consumidora);

        return `<div style="width:100%; display:flex; flex-direction:column; margin-top:150px; justify-content:center; align-items:center;"><h1>Diagnóstico de Energia</h1><h4>Cliente:${
            cliente.valor
        } - UC: ${uc.valor} - Período de ${
            props.filtro.competencia_inicial ? `${String(props.filtro.competencia_inicial).substring(4, 6)}/${String(props.filtro.competencia_inicial).substring(0, 4)}` : null
        } à ${
            props.filtro.competencia_final ? `${String(props.filtro.competencia_final).substring(4, 6)}/${String(props.filtro.competencia_final).substring(0, 4)}` : null
        }</h4></div>`;
    }

    function ModalTabelaExcedentes({ horario, horarioDescricao, setExibirModalExcedente }) {
        const [camposEditaveis, setCamposEditaveis] = useState(false);
        const [listaExcedente, setListaExcedente] = useState(props.situacaoAtual.lista_energia_excedente || []);

        return (
            <ModalAlert
                titulo={`Ajuste das Tarifas de Energia Excedente ${horarioDescricao}`}
                handleClose={() => {
                    setExibirModalExcedente(false);
                }}
            >
                <div>
                    <div style={{ maxHeight: 300, overflowY: "auto" }}>
                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                            <thead>
                                <tr
                                    style={{
                                        position: "sticky",
                                        zIndex: 1,
                                        backgroundColor: "#586269",
                                        color: "#FFF",
                                        height: 40,
                                        top: 0,
                                    }}
                                >
                                    <th style={{ textAlign: "center" }}>Mês</th>
                                    <th style={{ textAlign: "center" }}>Posto Horário</th>
                                    <th style={{ textAlign: "center" }}>Qtd. Inj.</th>
                                    <th style={{ textAlign: "center" }}>Tarifa Considerada</th>
                                    <th style={{ textAlign: "center" }}>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaExcedente.map((e, i) => {
                                    return (
                                        <>
                                            <tr key={e.competencia} style={{ borderBlock: "1px solid #ccc", paddingTop: 30 }}>
                                                <td style={{ paddingInline: 50 }}>{String(e.competencia).substring(4, 6) + "/" + String(e.competencia).substring(0, 4)}</td>
                                                <td style={{ textAlign: "center" }}>{horarioDescricao}</td>
                                                <td style={{ textAlign: "center" }}>
                                                    {e[`quantidade_energia_excedente_${horario}`]
                                                        ? adicionarPontosMilhar(e[`quantidade_energia_excedente_${horario}`]) + " kWh"
                                                        : " - "}
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <NumberFormat
                                                        className="form-control"
                                                        style={{
                                                            textAlign: "center",
                                                            height: 20,
                                                            fontSize: 13,
                                                            boxShadow: parseFloat(Math.abs(e[`tarifa_energia_excedente_${horario}`] || 0)) ? null : "#ee224e 0px 0px 2px 1px",
                                                        }}
                                                        disabled={!camposEditaveis}
                                                        placeholder={"0"}
                                                        decimalSeparator={","}
                                                        decimalScale={6}
                                                        fixedDecimalScale={6}
                                                        value={String(e[`tarifa_energia_excedente_${horario}`] || "")
                                                            .replace(".", ",")
                                                            .replace("-", "")}
                                                        onValueChange={(values) => {
                                                            const valor = values.floatValue || 0;
                                                            setListaExcedente(
                                                                listaExcedente.map((item, idx) =>
                                                                    i === idx
                                                                        ? {
                                                                              ...item,
                                                                              [`tarifa_energia_excedente_${horario}`]: values.value,
                                                                              [`valor_energia_excedente_${horario}`]:
                                                                                  item[`quantidade_energia_excedente_${horario}`] * (valor < 0 ? valor : valor * -1),
                                                                          }
                                                                        : item
                                                                )
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ textAlign: "center", minWidth: 200 }}>
                                                    {e[`valor_energia_excedente_${horario}`] ? "R$ " + adicionarPontosMilhar(e[`valor_energia_excedente_${horario}`]) : " - "}
                                                </td>
                                            </tr>
                                        </>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-center align-items-center">
                        {camposEditaveis ? (
                            <>
                                <Button
                                    style={{ width: window.innerWidth < 768 ? "50%" : 120, height: 40, margin: 10 }}
                                    text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Salvar</span>}
                                    title="Salvar"
                                    type={"success"}
                                    icon={"fa fa-check"}
                                    event={() => {
                                        props.setSituacaoAtual({
                                            ...props.situacaoAtual,
                                            lista_energia_excedente: listaExcedente,
                                        });
                                        setExibirModalExcedente(false);
                                    }}
                                />
                                <Button
                                    style={{ width: window.innerWidth < 768 ? "50%" : 120, height: 40, margin: 10 }}
                                    text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Cancelar</span>}
                                    title="Cancelar"
                                    type={"danger"}
                                    icon={"fa fa-times"}
                                    event={() => {
                                        setCamposEditaveis(false);
                                        setListaExcedente(props.situacaoAtual.lista_energia_excedente || []);
                                    }}
                                />
                            </>
                        ) : (
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120, height: 40, margin: 10 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Editar</span>}
                                title="Editar"
                                type={"warning"}
                                icon={"fa fa-pencil-alt"}
                                event={() => setCamposEditaveis(true)}
                            />
                        )}
                    </div>
                </div>
            </ModalAlert>
        );
    }

    const qtdTotalExcedenteForaPonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_fora_ponta), 0);
    const valorTotalExcedenteForaPonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.valor_energia_excedente_fora_ponta), 0);
    const existeFaturaSemTarifaForaPonta = !!(props.situacaoAtual.lista_energia_excedente || []).find((item) => !item.tarifa_energia_excedente_fora_ponta);

    const qtdTotalExcedentePonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.quantidade_energia_excedente_ponta), 0);
    const valorTotalExcedentePonta = (props.situacaoAtual.lista_energia_excedente || []).reduce((acc, item) => (acc += item.valor_energia_excedente_ponta), 0);
    const existeFaturaSemTarifaPonta = !!(props.situacaoAtual.lista_energia_excedente || []).find((item) => !item.tarifa_energia_excedente_ponta);

    //se for grupo B ou A fat em B usa a tarifa unica, pois B não tem posto horário
    const faturaEmB = [2, 3].includes(ucFiltrada.id_grupo_faturamento);

    const listaUcsFiltradas = listarUCsFiltradas();
    const listaGrupoFaturamentoModificada = props.listaGrupoFaturamento.filter((item) => [1, 2].includes(item.id));
    listaGrupoFaturamentoModificada.push({ id: "[3,4]", valor: "Unidades Grupo A (Optantes)" });
    return (
        <div>
            {props.aguardando || loading ? <Loading /> : null}
            {exibirModalExcedenteForaPonta && (
                <ModalTabelaExcedentes
                    horario="fora_ponta"
                    horarioDescricao={faturaEmB ? "Não se Aplica" : "Fora Ponta"}
                    setExibirModalExcedente={setExibirModalExcedenteForaPonta}
                />
            )}
            {exibirModalExcedentePonta && (
                <ModalTabelaExcedentes horario="ponta" horarioDescricao={faturaEmB ? "Não se Aplica" : "Ponta"} setExibirModalExcedente={setExibirModalExcedentePonta} />
            )}
            <ModalGestorConcessonaria
                visible={exibirModalGestorConcessionaria && itemSelecionado && itemSelecionado.gestor_concessionaria_energia}
                itemSelecionado={itemSelecionado}
                handleClose={() => {
                    setExibirModalGestorConcessionaria(false);
                    setItemSelecionado(null);
                }}
            />
            <Content>
                <ContentCard>
                    <ContentCardHeader>
                        <Row style={{ paddingBlock: 15 }}>
                            {!usuarioLogadoAcessoCliente ? (
                                <Select
                                    readOnly={props.aguardando}
                                    name="id_cliente"
                                    options={props.listaCliente}
                                    label="Cliente"
                                    cols="12 12 5 5"
                                    placeholder="Selecione o Cliente"
                                    value={props.filtro.id_cliente}
                                    onChange={(value) => {
                                        props.setFiltro({
                                            ...props.filtro,
                                            id_cliente: value,
                                            id_unidade_consumidora: null,
                                        });
                                        setTipoAnalise(null);
                                        setExibirSelectTipoAnalise(false);
                                    }}
                                />
                            ) : null}

                            <Select
                                readOnly={props.aguardando}
                                name="id_grupo_faturamento"
                                options={listaGrupoFaturamentoModificada}
                                label="Tipo de Faturamento"
                                cols="12 12 2 2"
                                placeholder="Selecione o tipo de faturamento"
                                isSearchable={false}
                                value={props.filtro.id_grupo_faturamento}
                                onChange={(id_grupo_faturamento) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_grupo_faturamento,
                                    });
                                }}
                            />
                            <Select
                                readOnly={props.aguardando}
                                options={listaUcsFiltradas}
                                label={
                                    <LabelSelectUcIconeGestor
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={listaUcsFiltradas}
                                        setExibirModal={(ucFiltro) => {
                                            setExibirModalGestorConcessionaria(true);
                                            setItemSelecionado(ucFiltro);
                                        }}
                                    />
                                }
                                cols={usuarioLogadoAcessoCliente ? "12 12 10 10" : "12 12 3 3"}
                                placeholder="Selecione a UC"
                                value={props.filtro.id_unidade_consumidora}
                                onChange={(value) => {
                                    const ucFiltrada = props.listaUnidadeConsumidora.find((item) => item.id == value) || null;
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_unidade_consumidora: value,
                                        id_cliente: ucFiltrada ? ucFiltrada.id_cliente : props.filtro.id_cliente,
                                        id_grupo_faturamento: ucFiltrada ? ucFiltrada.id_grupo_faturamento : props.filtro.id_grupo_faturamento,
                                    });

                                    setTipoAnalise(null);
                                    setExibirSelectTipoAnalise(false);
                                }}
                            />
                            <Grid cols="12 12 2 2" style={{ padding: "27px 5px" }}>
                                <Button
                                    text="Gerar Situação Atual"
                                    type={"primary"}
                                    icon={"fa fa-sync"}
                                    style={{ margin: 0 }}
                                    event={() => {
                                        if (!props.filtro.id_unidade_consumidora) {
                                            setInfo("Selecione uma UC para gerar a situação atual.");
                                            return;
                                        }
                                        props.buscarSituacaoAtual();
                                        setAnalises([]);
                                    }}
                                />
                            </Grid>
                            <Grid cols="12 12 5 5">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="Competência Inicial"
                                        autoOk
                                        value={
                                            props.filtro.competencia_inicial
                                                ? `${String(props.filtro.competencia_inicial).substring(0, 4)}/${String(props.filtro.competencia_inicial).substring(
                                                      4,
                                                      6
                                                  )}/01 12:00:00`
                                                : null
                                        }
                                        onChange={(value) => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                competencia_inicial: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                            });
                                        }}
                                        fullWidth
                                        InputProps={{
                                            style: {
                                                color: "#222", // cor do texto digitado
                                            },
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: "#222", // cor do label/flutuante
                                            },
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid cols="12 12 5 5">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="Competência Final"
                                        autoOk
                                        value={
                                            props.filtro.competencia_final
                                                ? `${String(props.filtro.competencia_final).substring(0, 4)}/${String(props.filtro.competencia_final).substring(4, 6)}/01 12:00:00`
                                                : null
                                        }
                                        onChange={(value) => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                competencia_final: value ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`) : null,
                                            });
                                        }}
                                        fullWidth
                                        InputProps={{
                                            style: {
                                                color: "#333", // cor do texto digitado
                                            },
                                        }}
                                        InputLabelProps={{
                                            style: {
                                                color: "#333", // cor do label/flutuante
                                            },
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid cols="12 12 2 2" style={{ padding: "10px 5px" }}>
                                <Button
                                    text="Imprimir"
                                    style={{ margin: 0 }}
                                    type={"info"}
                                    icon={"fas fa-print"}
                                    disabled={!analises.length}
                                    event={async (e) => {
                                        setLoading(true);
                                        await new Promise((resolve) => setTimeout(resolve, 1000));
                                        if (contentCardRef.current) {
                                            const tabelaAtual = contentCardRef.current.querySelector("#tabelaAtual");
                                            await formatarTabela({ el: tabelaAtual, borderColor: "#18a675" });

                                            let htmlTabelasAnalises = "";

                                            for (let i = 0; i < analises.length; i++) {
                                                const tabelaSimulada = contentCardRef.current.querySelector("#tabelaSimulada" + i);
                                                await formatarTabela({ el: tabelaSimulada, borderColor: "#58c5fb" });
                                                htmlTabelasAnalises +=
                                                    `<div style="width:46%; display:flex; align-items:center; padding-left:20px; justify-content:flex-end;">` +
                                                    (tabelaSimulada ? tabelaSimulada.outerHTML : "") +
                                                    "</div>";
                                            }

                                            let html = `<div style="border: 1px solid #DDD; width:100%; height:100%; display:flex; flex-direction:column; align-items:center; justify-content:flex-start;">`;

                                            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
                                            const htmlCabecalho = `<div style="width:100%; height:10%;font-family: Arial, sans-serif;">
                                                                    <img src="${base64Cabecalho}" width="100%" />
                                                                </div>`;

                                            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
                                            const htmlRodape = `<div style="width:100%; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                                                        <img src="${base64Rodape}" width="100%" />
                                                                </div> `;
                                            html += htmlCabecalho;

                                            html += getTituloImpressao(props);
                                            html += `<div style="width:100%; height:80%; display:flex; align-items:flex-start; justify-content:center;">`;
                                            html +=
                                                `<div style="width:46%; display:flex; align-items:center; padding-right:20px; justify-content:flex-start;">` +
                                                (tabelaAtual ? tabelaAtual.outerHTML : "") +
                                                "</div>";
                                            html += htmlTabelasAnalises;
                                            html += "</div>";
                                            html += htmlRodape;
                                            html += "</div>";
                                            // Gera o relatório com o HTML atualizado

                                            await props.gerarRelatorio({
                                                html,
                                                landscape: true,
                                                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.55,
                                            });
                                        } else {
                                            console.error("Conteúdo não está acessível.");
                                        }
                                        setLoading(false);
                                    }}
                                />
                            </Grid>

                            {props.situacaoAtual.competencias_sem_faturas && props.situacaoAtual.competencias_sem_faturas.length > 0 && (
                                <Grid cols="12 12 12 12" style={{ padding: 10 }}>
                                    <div style={{ display: "flex", fontWeight: 500, fontSize: "1.2rem" }}>
                                        <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                        <span style={{ margin: "6px 0 0 6px" }}>
                                            Faltam faturas no período selecionado, ajuste o período filtrado.
                                            <span style={{ color: "#ff003c" }}>
                                                {" "}
                                                Meses em falta:{" "}
                                                {props.situacaoAtual.competencias_sem_faturas.map((item, i, lista) => (
                                                    <span key={item}>
                                                        {item}
                                                        {i == lista.length - 1 ? "." : ", "}
                                                    </span>
                                                ))}
                                            </span>
                                        </span>
                                    </div>
                                </Grid>
                            )}
                        </Row>
                    </ContentCardHeader>
                    <ContentCardBody>
                        <div ref={contentCardRef}>
                            <Row>
                                <Grid cols="12 12 5 5" style={{ padding: 10 }}>
                                    <div style={{ flex: "0 0 auto" }}>
                                        <Table id="tabelaAtual" responsive tableBorder="2px solid #18a675" borderRadius={8} minHeight={500}>
                                            <THead>
                                                <Tr>
                                                    <Th colSpan={4} alignCenter backgroundColor="#18a675" color="#FFF">
                                                        Situação Atual
                                                    </Th>
                                                </Tr>
                                            </THead>
                                            <TBody>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Tipo de mercado
                                                    </Td>
                                                    <Td width={200} alignCenter colSpan={2}>
                                                        {ucFiltrada.nome_tipo_mercado ? ucFiltrada.nome_tipo_mercado : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Modalidade tarifária
                                                    </Td>
                                                    <Td width={200} alignCenter colSpan={2}>
                                                        {ucFiltrada.nome_modalidade_tarifaria ? ucFiltrada.nome_modalidade_tarifaria : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Grupo de Faturamento
                                                    </Td>
                                                    <Td width={200} alignCenter colSpan={2}>
                                                        {ucFiltrada.nome_grupo_faturamento ? ucFiltrada.nome_grupo_faturamento : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Subgrupo de Faturamento
                                                    </Td>
                                                    <Td width={200} alignCenter colSpan={2}>
                                                        {ucFiltrada.nome_subgrupo_faturamento ? ucFiltrada.nome_subgrupo_faturamento : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#18a675" color="#ecf5fd" paddingLeft={4} colSpan={2}>
                                                        Descrição
                                                    </Td>
                                                    <Td backgroundColor="#18a675" color="#ecf5fd" width={200} alignCenter>
                                                        Quantidade
                                                    </Td>
                                                    <Td backgroundColor="#18a675" color="#ecf5fd" width={200} alignCenter>
                                                        R$
                                                    </Td>
                                                </Tr>

                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} rowSpan={2}>
                                                        Energia Ponta
                                                    </Td>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4}>
                                                        TUSD
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        <div
                                                            style={{
                                                                boxShadow:
                                                                    props.situacaoAtual.quantidade_energia_ponta && ucFiltrada.id_grupo_faturamento == 3
                                                                        ? "#ee224e 0px 0px 2px 1px"
                                                                        : null,
                                                            }}
                                                            title={
                                                                !props.situacaoAtual.quantidade_energia_ponta
                                                                    ? "Favor verifica o período selecionado ou o cadastro atual da UC, pois UC grupo A faturado em B não deveria ter energia ponta"
                                                                    : ""
                                                            }
                                                        >
                                                            {props.situacaoAtual.quantidade_energia_ponta
                                                                ? adicionarPontosMilhar(props.situacaoAtual.quantidade_energia_ponta, 6) + " kWh"
                                                                : " - "}
                                                        </div>
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.valor_energia_ponta_tusd
                                                            ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_energia_ponta_tusd, 6)
                                                            : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4}>
                                                        TE
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        <div
                                                            style={{
                                                                boxShadow:
                                                                    props.situacaoAtual.quantidade_energia_ponta && ucFiltrada.id_grupo_faturamento == 3
                                                                        ? "#ee224e 0px 0px 2px 1px"
                                                                        : null,
                                                            }}
                                                            title={
                                                                !props.situacaoAtual.quantidade_energia_ponta
                                                                    ? "Favor verifica o período selecionado ou o cadastro atual da UC, pois UC grupo A faturado em B não deveria ter energia ponta"
                                                                    : ""
                                                            }
                                                        >
                                                            {props.situacaoAtual.quantidade_energia_ponta
                                                                ? adicionarPontosMilhar(props.situacaoAtual.quantidade_energia_ponta, 6) + " kWh"
                                                                : " - "}
                                                        </div>
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        <div>
                                                            {props.situacaoAtual.valor_energia_ponta_te
                                                                ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_energia_ponta_te, 6)
                                                                : " - "}
                                                        </div>
                                                        {props.situacaoAtual.quantidade_energia_ponta > 0 ? (
                                                            <div>
                                                                {`\n(${adicionarPontosMilhar(
                                                                    props.situacaoAtual.valor_energia_ponta_te / props.situacaoAtual.quantidade_energia_ponta,
                                                                    6
                                                                )} R$/kWh)`}
                                                            </div>
                                                        ) : null}
                                                    </Td>
                                                </Tr>

                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} rowSpan={2}>
                                                        Energia Fora Ponta
                                                    </Td>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4}>
                                                        TUSD
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.quantidade_energia_fora_ponta
                                                            ? adicionarPontosMilhar(props.situacaoAtual.quantidade_energia_fora_ponta, 6) + " kWh"
                                                            : " - "}
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.valor_energia_fora_ponta_tusd
                                                            ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_energia_fora_ponta_tusd, 6)
                                                            : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4}>
                                                        TE
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.quantidade_energia_fora_ponta
                                                            ? adicionarPontosMilhar(props.situacaoAtual.quantidade_energia_fora_ponta, 6) + " kWh"
                                                            : " - "}
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        <div>
                                                            {props.situacaoAtual.valor_energia_fora_ponta_te
                                                                ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_energia_fora_ponta_te, 6)
                                                                : " - "}
                                                        </div>
                                                        {props.situacaoAtual.quantidade_energia_fora_ponta > 0 ? (
                                                            <div>
                                                                {`\n(${adicionarPontosMilhar(
                                                                    props.situacaoAtual.valor_energia_fora_ponta_te / props.situacaoAtual.quantidade_energia_fora_ponta,
                                                                    6
                                                                )} R$/kWh)`}
                                                            </div>
                                                        ) : null}
                                                    </Td>
                                                </Tr>
                                                {!!ucFiltrada.irrigante && (
                                                    <>
                                                        <Tr style={{ fontWeight: "450" }}>
                                                            <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} rowSpan={2}>
                                                                Energia Reservado
                                                            </Td>
                                                            <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4}>
                                                                TUSD
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {props.situacaoAtual.quantidade_energia_reservado
                                                                    ? adicionarPontosMilhar(props.situacaoAtual.quantidade_energia_reservado, 6) + " kWh"
                                                                    : " - "}
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {props.situacaoAtual.valor_energia_reservado_tusd
                                                                    ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_energia_reservado_tusd, 6)
                                                                    : " - "}
                                                            </Td>
                                                        </Tr>
                                                        <Tr style={{ fontWeight: "450" }}>
                                                            <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4}>
                                                                TE
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {props.situacaoAtual.quantidade_energia_reservado
                                                                    ? adicionarPontosMilhar(props.situacaoAtual.quantidade_energia_reservado, 6) + " kWh"
                                                                    : " - "}
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                <div>
                                                                    {props.situacaoAtual.valor_energia_reservado_te
                                                                        ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_energia_reservado_te, 6)
                                                                        : " - "}
                                                                </div>
                                                                {props.situacaoAtual.quantidade_energia_reservado > 0 ? (
                                                                    <div>
                                                                        {`\n(${adicionarPontosMilhar(
                                                                            props.situacaoAtual.valor_energia_reservado_te / props.situacaoAtual.quantidade_energia_reservado,
                                                                            6
                                                                        )} R$/kWh)`}
                                                                    </div>
                                                                ) : null}
                                                            </Td>
                                                        </Tr>
                                                    </>
                                                )}
                                                {!!(ucFiltrada.geracao || ucFiltrada.id_unidade_geradora) && (
                                                    <>
                                                        <Tr style={{ fontWeight: "450" }}>
                                                            <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                                Energia Excedente/Injetada Fora Ponta
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {qtdTotalExcedenteForaPonta ? adicionarPontosMilhar(qtdTotalExcedenteForaPonta, 6) + " kWh" : " - "}
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {loading ? (
                                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        {existeFaturaSemTarifaForaPonta ? (
                                                                            <AlertIcon animationClass={"alerta-triangulo-visualizado"} width={25} height={25} event={() => {}} />
                                                                        ) : null}
                                                                        <span style={{ paddingTop: 4, paddingLeft: 10 }}>
                                                                            {valorTotalExcedenteForaPonta ? "R$ " + adicionarPontosMilhar(valorTotalExcedenteForaPonta, 6) : " - "}
                                                                        </span>
                                                                        {/* <span style={{ margin: "6px 0 0 6px" }}>Verificar</span> */}
                                                                    </div>
                                                                ) : (
                                                                    <Button
                                                                        hoverStyle={{ filter: "brightness(1.1)" }}
                                                                        style={{
                                                                            width: "fit-content",
                                                                            padding: "0px 8px",
                                                                            backgroundColor: "#dfdfdf",
                                                                            color: existeFaturaSemTarifaForaPonta ? "#ff3131" : "#000",
                                                                            fontWeight: 500,
                                                                        }}
                                                                        text={
                                                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                                {existeFaturaSemTarifaForaPonta ? (
                                                                                    <AlertIcon
                                                                                        animationClass={"alerta-triangulo-visualizado"}
                                                                                        width={25}
                                                                                        height={25}
                                                                                        event={() => {}}
                                                                                    />
                                                                                ) : null}
                                                                                <span style={{ paddingTop: 4, paddingLeft: 10 }}>
                                                                                    {valorTotalExcedenteForaPonta
                                                                                        ? "R$ " + adicionarPontosMilhar(valorTotalExcedenteForaPonta, 6)
                                                                                        : " - "}
                                                                                </span>
                                                                                {/* <span style={{ margin: "6px 0 0 6px" }}>Verificar</span> */}
                                                                            </div>
                                                                        }
                                                                        title="Exitem faturas sem tarifa de excedente Fora Ponta"
                                                                        event={() => {
                                                                            setExibirModalExcedenteForaPonta(true);
                                                                        }}
                                                                    />
                                                                )}
                                                            </Td>
                                                        </Tr>
                                                        <Tr style={{ fontWeight: "450" }}>
                                                            <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                                Energia Excedente/Injetada Ponta
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {qtdTotalExcedentePonta ? adicionarPontosMilhar(qtdTotalExcedentePonta, 6) + " kWh" : " - "}
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {loading ? (
                                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                        {existeFaturaSemTarifaPonta ? (
                                                                            <AlertIcon animationClass={"alerta-triangulo-visualizado"} width={25} height={25} event={() => {}} />
                                                                        ) : null}
                                                                        <span style={{ paddingTop: 4, paddingLeft: 10 }}>
                                                                            {valorTotalExcedentePonta ? "R$ " + adicionarPontosMilhar(valorTotalExcedentePonta, 6) : " - "}
                                                                        </span>
                                                                        {/* <span style={{ margin: "6px 0 0 6px" }}>Verificar</span> */}
                                                                    </div>
                                                                ) : (
                                                                    <Button
                                                                        hoverStyle={{ filter: "brightness(1.1)" }}
                                                                        style={{
                                                                            width: "fit-content",
                                                                            padding: "0px 8px",
                                                                            backgroundColor: "#dfdfdf",
                                                                            color: existeFaturaSemTarifaPonta ? "#ff3131" : "#000",
                                                                            fontWeight: 500,
                                                                        }}
                                                                        text={
                                                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                                                {existeFaturaSemTarifaPonta ? (
                                                                                    <AlertIcon
                                                                                        animationClass={"alerta-triangulo-visualizado"}
                                                                                        width={25}
                                                                                        height={25}
                                                                                        event={() => {}}
                                                                                    />
                                                                                ) : null}
                                                                                <span style={{ paddingTop: 4, paddingLeft: 10 }}>
                                                                                    {valorTotalExcedentePonta ? "R$ " + adicionarPontosMilhar(valorTotalExcedentePonta, 6) : " - "}
                                                                                </span>
                                                                                {/* <span style={{ margin: "6px 0 0 6px" }}>Verificar</span> */}
                                                                            </div>
                                                                        }
                                                                        title="Exitem faturas sem tarifa de excedente Ponta"
                                                                        event={() => {
                                                                            setExibirModalExcedentePonta(true);
                                                                        }}
                                                                    />
                                                                )}
                                                            </Td>
                                                        </Tr>
                                                    </>
                                                )}
                                                {ucFiltrada.id_modalidade_tarifaria == 2 && (
                                                    <>
                                                        <Tr style={{ fontWeight: "450" }}>
                                                            <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                                Demanda Ponta
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {props.situacaoAtual.quantidade_demanda_ponta
                                                                    ? adicionarPontosMilhar(props.situacaoAtual.quantidade_demanda_ponta, 6) + " kW"
                                                                    : " - "}
                                                            </Td>
                                                            <Td width={200} alignCenter>
                                                                {props.situacaoAtual.valor_demanda_ponta
                                                                    ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_demanda_ponta, 6)
                                                                    : " - "}
                                                            </Td>
                                                        </Tr>
                                                        {exibirUltrapassagemDemanda && (
                                                            <Tr style={{ fontWeight: "450" }}>
                                                                <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                                    Ultrapassagem de Demanda Ponta
                                                                </Td>
                                                                <Td width={200} alignCenter>
                                                                    {props.situacaoAtual.quantidade_ultrapassagem_demanda_ponta
                                                                        ? adicionarPontosMilhar(props.situacaoAtual.quantidade_demanda_ponta, 6) + " kW"
                                                                        : " - "}
                                                                </Td>
                                                                <Td width={200} alignCenter>
                                                                    {props.situacaoAtual.valor_demanda_ponta
                                                                        ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_ultrapassagem_demanda_ponta, 6)
                                                                        : " - "}
                                                                </Td>
                                                            </Tr>
                                                        )}
                                                    </>
                                                )}
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Demanda Fora Ponta
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.quantidade_demanda_fora_ponta
                                                            ? adicionarPontosMilhar(props.situacaoAtual.quantidade_demanda_fora_ponta, 6) + " kW"
                                                            : " - "}
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.valor_demanda_fora_ponta
                                                            ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_demanda_fora_ponta, 6)
                                                            : " - "}
                                                    </Td>
                                                </Tr>
                                                {exibirUltrapassagemDemanda && (
                                                    <Tr style={{ fontWeight: "450" }}>
                                                        <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                            Ultrapassagem de Demanda Fora Ponta
                                                        </Td>
                                                        <Td width={200} alignCenter>
                                                            {props.situacaoAtual.quantidade_ultrapassagem_demanda_fora_ponta
                                                                ? adicionarPontosMilhar(props.situacaoAtual.quantidade_ultrapassagem_demanda_fora_ponta, 6) + " kW"
                                                                : " - "}
                                                        </Td>
                                                        <Td width={200} alignCenter>
                                                            {props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta
                                                                ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta, 6)
                                                                : " - "}
                                                        </Td>
                                                    </Tr>
                                                )}
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Impostos
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        N/A
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.valor_imposto ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_imposto, 6) : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#ecf5fd" color="#1d6254" paddingLeft={4} colSpan={2}>
                                                        Bandeiras
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        N/A
                                                    </Td>
                                                    <Td width={200} alignCenter>
                                                        {props.situacaoAtual.valor_bandeira ? "R$ " + adicionarPontosMilhar(props.situacaoAtual.valor_bandeira, 6) : " - "}
                                                    </Td>
                                                </Tr>
                                                <Tr style={{ fontWeight: "450" }}>
                                                    <Td backgroundColor="#18a675" color="#ecf5fd" paddingLeft={4} colSpan={2}>
                                                        Total
                                                    </Td>
                                                    <Td backgroundColor="#18a675" color="#ecf5fd" width={200} alignCenter>
                                                        =
                                                    </Td>
                                                    <Td backgroundColor="#18a675" color="#ecf5fd" width={200} alignCenter>
                                                        {"R$ " +
                                                            adicionarPontosMilhar(
                                                                (parseFloat(props.situacaoAtual.valor_energia_ponta) || 0) +
                                                                    (parseFloat(props.situacaoAtual.valor_energia_fora_ponta) || 0) +
                                                                    (parseFloat(props.situacaoAtual.valor_energia_reservado) || 0) +
                                                                    (parseFloat(props.situacaoAtual.valor_demanda_ponta) || 0) +
                                                                    (parseFloat(props.situacaoAtual.valor_demanda_fora_ponta) || 0) +
                                                                    (parseFloat(valorTotalExcedenteForaPonta) || 0) +
                                                                    (parseFloat(valorTotalExcedentePonta) || 0) +
                                                                    (exibirUltrapassagemDemanda ? parseFloat(props.situacaoAtual.valor_ultrapassagem_demanda_fora_ponta) || 0 : 0) +
                                                                    (parseFloat(props.situacaoAtual.valor_imposto) || 0) +
                                                                    (parseFloat(props.situacaoAtual.valor_bandeira) || 0)
                                                            )}
                                                    </Td>
                                                </Tr>
                                            </TBody>
                                        </Table>
                                        <Row style={{ marginBlock: 30 }}>
                                            <LabelAndCheckbox
                                                style={{ justifyContent: "center" }}
                                                id="exibir-ultrapassagem-demanda"
                                                label={`Considerar Possíveis Ultrapassagens de Demanda na Simulação`}
                                                onChange={(e) => setExibirUltrapassagemDemanda(!exibirUltrapassagemDemanda)}
                                                value={exibirUltrapassagemDemanda}
                                            />
                                        </Row>
                                    </div>
                                </Grid>

                                <Grid cols="12 12 2 2" style={{ padding: 10, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    {exibirSelectTipoAnalise ? (
                                        <Row>
                                            <Select
                                                options={listaTipoAnaliseFiltrada}
                                                readOnly={!listaTipoAnaliseFiltrada.length}
                                                label="Tipo de Diagnóstico"
                                                cols="12 12 12 12"
                                                placeholder="Selecione o tipo"
                                                value={tipoAnalise}
                                                isSearchable={false}
                                                isClearable={false}
                                                onChange={(value) => {
                                                    setTipoAnalise(value);
                                                }}
                                            />
                                            <Grid cols="12 12 6 6" style={{ padding: 3, display: "flex", alignItems: "center" }}>
                                                <Button
                                                    title="Confirmar"
                                                    text={<span style={{ fontSize: "0.75rem" }}>Confirmar</span>}
                                                    type={"success"}
                                                    solid={true}
                                                    icon={"fa fa-check"}
                                                    style={{ margin: window.innerWidth < 768 ? 0 : null, fontSize: "0.5rem !important" }}
                                                    event={() => {
                                                        if (!["Opção Tarifária (Optantes A ou B)", "Mercado Livre"].includes(tipoAnalise)) {
                                                            setWarning(
                                                                `Apenas os diagnósticos de "Mercado Livre" e "Opção Tarifária (Optantes A ou B)" estão implementados no momento.`
                                                            );
                                                            return;
                                                        }
                                                        if (analises.find((item) => item.tipoAnalise === tipoAnalise)) {
                                                            setWarning(`A diagnóstico do tipo "${tipoAnalise}" já foi incluído`);
                                                            return;
                                                        }

                                                        //simula uma aliquota criando uma proporção do valor do imposto da situação atual em relação ao subtotal da situação atual
                                                        const subtotal =
                                                            (parseFloat(props.situacaoAtual.valor_energia_ponta) || 0) +
                                                            (parseFloat(props.situacaoAtual.valor_energia_fora_ponta) || 0) +
                                                            (parseFloat(props.situacaoAtual.valor_energia_reservado) || 0) +
                                                            (parseFloat(props.situacaoAtual.valor_demanda_ponta) || 0) +
                                                            (parseFloat(props.situacaoAtual.valor_demanda_fora_ponta) || 0) +
                                                            (parseFloat(props.situacaoAtual.valor_bandeira) || 0);
                                                        setAnalises([
                                                            {
                                                                tipoAnalise,
                                                                dados: {
                                                                    ...props.situacaoAtual,
                                                                    aliquota_calculada: subtotal > 0 ? (100 * (parseFloat(props.situacaoAtual.valor_imposto) || 0)) / subtotal : 0,
                                                                    valor_energia_ponta_te: 0,
                                                                    valor_energia_fora_ponta_te: 0,
                                                                    valor_energia_reservado_te: 0,
                                                                },
                                                            },
                                                            ...analises,
                                                        ]);
                                                        setExibirSelectTipoAnalise(false);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid cols="12 12 6 6" style={{ padding: 3, display: "flex", alignItems: "center" }}>
                                                <Button
                                                    title="Cancelar"
                                                    text={<span style={{ fontSize: "0.75rem" }}>Cancelar</span>}
                                                    type={"danger"}
                                                    solid={true}
                                                    icon={"fa fa-times"}
                                                    style={{ margin: window.innerWidth < 768 ? 0 : null }}
                                                    event={() => {
                                                        setTipoAnalise(null);
                                                        setExibirSelectTipoAnalise(false);
                                                    }}
                                                />
                                            </Grid>
                                        </Row>
                                    ) : (
                                        <div className="d-flex flex-column">
                                            {JSON.stringify(props.situacaoAtual) === "{}" ? (
                                                <div style={{ fontSize: "0.8rem", textAlign: "center", color: "#444" }}>
                                                    {" "}
                                                    Selecione uma UC, um período e clique em "Gerar Situação Atual" para liberar o diagnóstico
                                                </div>
                                            ) : null}
                                            <Button
                                                title={listaTipoAnaliseFiltrada.length ? "Incluir Diagnóstico" : "Todos diagnóstico já foram incluídos"}
                                                disabled={JSON.stringify(props.situacaoAtual) === "{}" || !listaTipoAnaliseFiltrada.length}
                                                text={
                                                    <span style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        Incluir Diagnóstico <i className="ml-2 fas fa-long-arrow-alt-right" style={{ fontSize: "1.2rem" }}></i>
                                                    </span>
                                                }
                                                type={"primary"}
                                                solid={true}
                                                style={{ margin: 0 }}
                                                event={() => {
                                                    setExibirSelectTipoAnalise(true);
                                                    setTipoAnalise(listaTipoAnaliseFiltrada[0] ? listaTipoAnaliseFiltrada[0].valor : "");
                                                }}
                                            />
                                        </div>
                                    )}
                                </Grid>

                                <Grid cols="12 12 5 5">
                                    <div
                                        className="custom-scroll"
                                        style={{
                                            overflowX: "auto",
                                            backgroundColor: analises.length ? "#222" : null,
                                            border: analises.length ? "10px solid #222" : "none",
                                            borderRadius: 8,
                                        }}
                                    >
                                        <div style={{ display: "flex", flexWrap: "nowrap", justifyContent: "space-around", gap: 10 }}>
                                            {analises.map((analise, i) => (
                                                <div key={analise.tipoAnalise} style={{ flex: "0 0 auto", minWidth: "100%", maxWidth: "100%" }}>
                                                    {analise.tipoAnalise === "Mercado Livre" && (
                                                        <RenderizarAnaliseMercadoLivre
                                                            id={"tabelaSimulada" + i}
                                                            tipoAnalise={analise.tipoAnalise}
                                                            dados={analise.dados}
                                                            ucFiltrada={ucFiltrada}
                                                            removerAnalise={removerAnalise}
                                                            atualizarAnalise={atualizarAnalise}
                                                            exibirUltrapassagemDemanda={exibirUltrapassagemDemanda}
                                                        />
                                                    )}
                                                    {analise.tipoAnalise === "Opção Tarifária (Optantes A ou B)" ? (
                                                        ucFiltrada.id_grupo_faturamento == 4 ? (
                                                            <RenderizarAnaliseOpcaoTarifariaOptanteAB
                                                                id={"tabelaSimulada" + i}
                                                                tipoAnalise={analise.tipoAnalise}
                                                                dados={analise.dados}
                                                                ucFiltrada={ucFiltrada}
                                                                removerAnalise={removerAnalise}
                                                                atualizarAnalise={atualizarAnalise}
                                                                exibirUltrapassagemDemanda={exibirUltrapassagemDemanda}
                                                            />
                                                        ) : ucFiltrada.id_grupo_faturamento == 3 ? (
                                                            <RenderizarAnaliseOpcaoTarifariaOptanteBA
                                                                id={"tabelaSimulada" + i}
                                                                tipoAnalise={analise.tipoAnalise}
                                                                dados={analise.dados}
                                                                ucFiltrada={ucFiltrada}
                                                                removerAnalise={removerAnalise}
                                                                atualizarAnalise={atualizarAnalise}
                                                                exibirUltrapassagemDemanda={exibirUltrapassagemDemanda}
                                                            />
                                                        ) : null
                                                    ) : null}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </Grid>
                            </Row>
                        </div>
                    </ContentCardBody>
                </ContentCard>
            </Content>
        </div>
    );

    function removerAnalise({ tipoAnalise }) {
        if (!tipoAnalise) return;
        const demaisAnalises = analises.filter((item) => item.tipoAnalise !== tipoAnalise);
        setAnalises([...demaisAnalises]);
    }

    function atualizarAnalise({ tipoAnalise, dados }) {
        if (!tipoAnalise) return;
        const demaisAnalises = analises.filter((item) => item.tipoAnalise !== tipoAnalise);
        setAnalises([{ tipoAnalise, dados }, ...demaisAnalises]);
    }

    function listarUCsFiltradas() {
        const ucsFiltradas = props.listaUnidadeConsumidora.filter((item) => {
            const filtroCLiente = (!props.filtro.id_cliente && props.usuarioLogado && props.usuarioLogado.administrador) || item.id_cliente == props.filtro.id_cliente;
            const gruposFaturamentoFiltro = JSON.parse(props.filtro.id_grupo_faturamento || "[]"); //unificou os 2 grupos em Unidades Grupo A (Optantes)
            const grupoFaturamentoValido =
                gruposFaturamentoFiltro instanceof Array
                    ? gruposFaturamentoFiltro.includes(item.id_grupo_faturamento)
                    : item.id_grupo_faturamento == props.filtro.id_grupo_faturamento;
            const filtroGrupoFaturamento = !props.filtro.id_grupo_faturamento || grupoFaturamentoValido;
            return filtroCLiente && filtroGrupoFaturamento;
        });
        return ucsFiltradas;
    }
}

const mapStateToProps = (state) => {
    return {
        sessao: state.auth.usuario,
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.diagnosticoEnergia.modoTela,
        aguardando: state.diagnosticoEnergia.aguardando,
        filtro: state.diagnosticoEnergia.filtro,
        situacaoAtual: state.diagnosticoEnergia.situacaoAtual,
        listaCliente: state.diagnosticoEnergia.listaCliente,
        listaUnidadeConsumidora: state.diagnosticoEnergia.listaUnidadeConsumidora,
        listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
        listaTipoAnalise: state.diagnosticoEnergia.listaTipoAnalise,
        listaModalidadeMercadoLivre: state.diagnosticoEnergia.listaModalidadeMercadoLivre,
        listaTipoEnergiaMercadoLivre: state.diagnosticoEnergia.listaTipoEnergiaMercadoLivre,
        pdf: state.displayPDF.pdf,
        id_pdf: state.displayPDF.id_pdf,
        nomePdf: state.displayPDF.nomePdf,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            setFiltro,
            buscarSituacaoAtual,
            setAguardando,
            getListaCliente,
            getListaUnidadeConsumidora,
            resetarFiltro,
            getListaModalidadeMercadoLivre,
            getListaTipoEnergiaMercadoLivre,
            gerarRelatorio,
            incluirDownloadRealizado,
            setArquivoPDF,
            setSituacaoAtual,
            getListaGrupoFaturamento,
            getListaSubgrupoFaturamento,
            getListaModalidadeTarifaria,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(DiagnosticoEnergia);
